<template>
    <section :class="['scrollable-container', disabled ? 'disabled' : null]">
        <slot />
    </section>
</template>

<script>
    import Ps from 'perfect-scrollbar';
    export default {
        name: 'ui-scrollable-container',
        mounted() {
            this.container = this.$el;
            if (!this.disabled) {
                Ps.initialize(this.container);
                Ps.update(this.container);
            }
        },
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            refresh() {
                Ps.update(this.container);
            },
        },
        beforeDestroy() {
            if (!this.disabled) {
                Ps.destroy(this.container);
            }
        },
    };
</script>

<style>
    .scrollable-container {
        /*height: 100%;*/
        height: calc(100vh - 88px);
        width: 100%;
        overflow: hidden;
        /*flex: 1;*/
    }

    .scrollable-container {
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// UiScrollableContainer.vue?216f9557